import { Account, Address, CountryCode, User as IUser } from '@brenger/api-client';

export enum UserActionTypes {
  SOCIAL_AUTH_START = 'USER/SOCIAL_AUTH_START',
  SOCIAL_AUTH_SUCCESS = 'USER/SOCIAL_AUTH_SUCCESS',
  SOCIAL_AUTH_FAILED = 'USER/SOCIAL_AUTH_FAILED',
  REGISTER_USER_START = 'USER/REGISTER_USER_START',
  REGISTER_USER_SUCCESS = 'USER/REGISTER_USER_SUCCESS',
  REGISTER_USER_FAILED = 'USER/REGISTER_USER_FAILED',
  REGISTER_USER_ERROR_RESET = 'USER/REGISTER_USER_ERROR_RESET',
  SET_USER_DETAILS = 'USER/SET_USER_DETAILS',
  SET_ACCOUNT_TYPE = 'USER/SET_ACCOUNT_TYPE',
  SET_WHAT_IS_MY_COUNTRY = 'USER/SET_WHAT_IS_MY_COUNTRY',
  RETRIEVE_CURRENT_COUNTRY = 'USER/RETRIEVE_CURRENT_COUNTRY',
}

export enum UserErrorTitles {
  USERNAME_EXIST = 'username is taken',
}

export enum UserProperties {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  PASSWORD = 'password',
  EMAIL = 'email',
  PHONE = 'phone',
  TERMSOFUSE = 'termsofuse',
}

export enum Company {
  NAME = 'name',
  LINE1 = 'line1',
  COUNTRY = 'country',
  POSTAL_CODE = 'postal_code',
  LOCALITY = 'locality',
  COC_NUMBER = 'coc_number',
  VAT_NUMBER = 'vat_number',
}
export interface PasswordReset {
  loading: boolean;
  error: string;
  success: boolean;
}

export interface PasswordNew {
  token: string;
  loading: boolean;
  error: string;
  success: boolean;
}

export interface UserDetails {
  first_name: string;
  last_name: string;
  password: string;
  email: string;
  phone: string;
  account: Account;
}
export interface User {
  id: string | null;
  fetching: boolean;
  loggedIn: boolean;
  loggedInMethod: string | null;
  userData: IUser | null;
  billingAddress: Address | null;
  errors: string;
  details: UserDetails | null;
  loading: boolean;
  registered: boolean;
  isBusiness: boolean;
  what_is_my_country: CountryCode;
}
